export var CheckboxListSubjects;
(function (CheckboxListSubjects) {
    CheckboxListSubjects["listWrapper"] = "checkboxlist-wrapper";
    CheckboxListSubjects["singleItem"] = "checkboxlist-single-checkbox";
    CheckboxListSubjects["selectAll"] = "checkboxlist-select-all";
    CheckboxListSubjects["unSelectAll"] = "checkboxlist-unselect-all";
})(CheckboxListSubjects || (CheckboxListSubjects = {}));
//# sourceMappingURL=checkbox-list-bult-test-subjects.enum.js.map